import { Platform } from "react-native";
import React, { useCallback, useEffect, useMemo } from "react";
import { HeaderButton } from "../../components";
import { StatusBar } from "expo-status-bar";
import { NoStorePage } from "../../features/StoreCreate/NoStorePage";
import { Onboarding } from "../../features/Onboarding/Onboarding";

import { StoreAdminNavigator } from "../../features/StoreAdmin/StoreAdminNavigator";
import { EmployeeRolesAdmin } from "../../features/EmployeeRoles/EmployeeRolesAdmin";
import { EmployeeRoleEdit } from "../../features/EmployeeRoles/EmployeeRoleEdit/EmployeeRoleEdit";
import { EmployeeRoleCreate } from "../../features/EmployeeRoles/EmployeeRoleCreate/EmployeeRoleCreate";
import { StorecastScreen } from "../../features/Storecast/Storecast/StorecastScreen";

import { TaskExecutionInstructions } from "../../features/RoutineOccasion/TaskExecutionInstructions/TaskExecutionInstructions";
import { TeamCreate } from "../../features/TeamCreate/TeamCreate";
import { TodoCreateScreen } from "../../features/TodoCreate/TodoCreate";
import { TodoEdit } from "../../features/TodoEdit/TodoEditNavigator";

import { WidgetRoutinePositivePercentageScreen } from "../../features/Storecast/Storecast/Widgets/WidgetChecklistsPositivePercentage/WidgetRoutinePositivePercentageScreen";
import { WidgetTaskCollectionScreen } from "../../features/Storecast/Storecast/Widgets/WidgetTaskCollection/WidgetTaskCollectionScreen";

import { useRegisterDevice } from "../../common/Utils/useRegisterDevice";
import { useRegisterUser } from "../../common/analytics";
import { Box, useTheme } from "arkh";

import { TodoCategoryScreen } from "../../features/TodoCategory/TodoCategoryScreen";
import { FileScreen } from "../../features/Files/FileScreen";
import { StorecastShowFile } from "../../features/Files/StorecastShowFile/StorecastShowFile";
import { useSizeClass } from "../../common/Utils/useSizeClass";
import { SizeClass } from "@/src/common/Utils/SizeClass";
import { FileFocus } from "../../features/Files/StorecastShowFile/FileFocus";
import { SupportScreen } from "../../features/Support/SupportScreen";
import { KPIEdit } from "../../features/KPIAdmin/Edit/KPIEdit";
import { StorecastCreate } from "../../features/StorecastCreate/StorecastCreate";

import { StoreAnalyticsScreen } from "../../features/StoreAnalytics/StoreAnalyticsScreen";
import { KPIAnalytics } from "../../features/KPIAnalytics/KPIAnalytics";
import { PLUProductEditScreen } from "../../features/PLU/PLUProductEdit/PLUProductEditScreen";
import { PLUProductCreateScreen } from "../../features/PLU/PLUProductCreate/PLUProductCreate";
import { PLUCategoryCreate } from "../../features/PLU/PLUCategoryCreate/PLUCategoryCreate";
import { PLUCategoryEdit } from "../../features/PLU/PLUCategoryEdit/PLUCategoryEdit";
import { SupportTeamSchedule } from "../../features/Team/TeamHomeNavigator/TeamSchedule/SupportTeamSchedule";
import { WebViewScreen } from "../../features/WebViewScreen/WebViewScreen";
import { EmaginWebview } from "../../features/EmaginWebView/EmaginWebView";

import { useIntlTokens } from "../../components/mobile/useIntlTokens";
import { UserLoggedInNavigator } from "./UserLoggedInNavigator";
import { useWidgetNavigationScreens } from "../../features/Storecast/Storecast/Widgets/useWidgetNavigationScreens";
import { EmployeeScheduleEdit } from "../../features/EmployeeSchedule/EmployeeScheduleEditStack";
import { KPICreate } from "../../features/KPIAdmin/Create/KPICreate";

import { KPICreateSubTeam } from "../../features/KPIAdmin/KPICreateSubTeam/KPICreateSubTeam";
import { KPIEditSubTeam } from "../../features/KPIAdmin/KPIEditSubTeam/KPIEditSubTeam";

import { RoutineEdit } from "../../features/RoutineAdmin/RoutineEdit";
import { TeamScheduleAdmin } from "../../features/TeamScheduleAdmin/TeamScheduleAdminScreen";
import { ActivatePLUFromStoreFilesScreen } from "../../features/StoreSuperAdminPanel/ActivatePLUFromStoreFiles";

import { webModalOptions } from "./WEB_MODAL_DEFAULT_WIDTH";
import { withWebModal } from "./withWebModal";
import { TeamPLUScreen } from "../../features/PLU/PLUScreen";
import { StorecastSettings } from "../../features/Storecast/Storecast/StorecastSettings/StorecastSettings";
import { KPI } from "../../features/KPI/KPI";
import { FileInfoScreen } from "../../features/Files/FileInfoScreen";

import { TeamScheduleHistoryStack } from "../../features/TeamScheduleHistory/TimeScheduleHistoryScreen";

import { TeamNavigator } from "../../features/Team/TeamNavigator";

import { FileNavigator } from "../../features/Files/FileNavigator";
import { RoutineDetailNavigator } from "../../features/RoutineOccasion/RoutineDetail/RoutineDetailNavigator";
import { RoutineOccasionNavigator } from "../../features/RoutineOccasion/RoutineOccasionScreen/RoutineOccasionNavigator";

import { LazyQueryNetworkBoundrary } from "../../components/mobile/QueryNetworkBoundrary";
import { graphql, useFragment, useLazyLoadQuery } from "react-relay";
import { UserLoggedInQuery } from "./__generated__/UserLoggedInQuery.graphql";
import { OrgHome } from "../../features/OrgHome/OrgHome";

import { ProfileNavigator } from "../../features/Profile/ProfileNavigator";

import { Features, hasFeatureInTier } from "../../useHasFeatureInTier";
import { StoreFeatureFlagProvider } from "../../useHasFeatureFlag";
import { ErrorFallbackWithLogout } from "./ErrorFallbackWithLogout";
import { AuthenticatedUsersHorizontalList } from "../../OS/AuthenticatedUsers/AuthenticatedUsersHorizontalList";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { FallbackProps } from "react-error-boundary";
import { OrgSpaceCreate } from "../../features/OrgHome/OrgSpaceCreate/OrgSpaceCreate";
import { OrgSpaceWidgetAdd } from "../../features/OrgHome/OrgSpaceWidgetAdd/OrgSpaceWidgetAdd";
import { OrgSpaceWidgetAddNote } from "../../features/OrgHome/OrgSpaceWidgetAddNote/OrgSpaceWidgetAddNote";
import { OrgStoreCreate } from "../../features/OrgHome/OrgStores/OrgStoreCreate";
import { OrgSpaceActiveInfoScreen } from "../../features/OrgHome/OrgSpaceActiveInfo/OrgSpaceActiveInfoScreen";
import { OrgSpaceWidgetAddFile } from "../../features/OrgHome/OrgSpaceWidgetAddFile/OrgSpaceWidgetAddFile";
import { OrgSpaceEdit } from "../../features/OrgHome/OrgSpaceEdit/OrgSpaceEdit";

import { WorkspaceTodoEditNavigator } from "../../features/OrgHome/WorkspaceTodos/WorkspaceTodoEdit/WorkspaceTodoEdit";
import { TodoResponseNumberScreen } from "../../features/TodoResponse/TodoResponseNumberScreen";
import { WorkspaceSignalEditNavigator } from "../../features/OrgHome/WorkspaceSignals/WorkspaceSignalEdit/WorkspaceSignalEdit";

import { PortalHost } from "@gorhom/portal";
import { AbsolutePopoverHostName } from "../../components/mobile/AbsolutePopover";
import { KPITeamScreen } from "../../features/KPITeam/KPITeamScreen";
import { TeamAdmin } from "../../features/TeamAdmin/TeamAdmin";
import { TodoEditMoveToCategory } from "../../features/TodoEdit/TodoEditMoveToCategory";
import { UserLoggedInQuery_query$key } from "./__generated__/UserLoggedInQuery_query.graphql";
import { LastVisitedTeamProvider } from "../../OS/VisitedTeam/LastVisitedTeamProvider";
import { SignalsScreen } from "../../features/Signals/Signals";
import { SignalDetailScreen } from "../../features/Signals/SignalDetailScreen";
import { OrgAdmin } from "../../features/OrgHome/OrgAdmin/OrgAdmin";
import { OrgUserInvite } from "../../features/OrgHome/OrgAdmin/OrgUsers/OrgUserInvite";
import { OrgUserEdit } from "../../features/OrgHome/OrgAdmin/OrgUsers/OrgUserEdit";
import { OrgWorkspaceCreate } from "../../features/OrgHome/OrgStores/OrgWorkspaceCreate";
import { SignalOpenedByScreen } from "../../features/Signals/SignalOpenedByScreen";
import { OrgWorkspaceAdmin } from "../../features/OrgHome/OrgWorkspaceAdmin/OrgWorkspaceAdmin";

import { useHandleNotificationPress } from "./useHandleNotificationPress";
import { ProductDateTrackerNavigator } from "../../features/Products/ProductDateTrackerNavigator";
import { Product } from "../../features/Product/Product";
import { useForceTimeZone } from "../../OS/Timezone";
import { WorkspaceTodoLinkProduct } from "../../features/OrgHome/WorkspaceTodos/WorkspaceTodoEdit/WorkspaceTodoLinkProduct";
import { WorkspaceProduct } from "../../features/WorkspaceProduct/WorkspaceProduct";
import { WorkspaceTodoReceivers } from "../../features/OrgHome/WorkspaceTodos/WorkspaceTodoEdit/WorkspaceTodoEditMain/WorkspaceTodoReceivers";
import { WorkspaceSignalReceivers } from "../../features/OrgHome/WorkspaceSignals/WorkspaceSignalEdit/WorkspaceSignalEditMain/WorkspaceSignalReceivers";
import { WorkspaceTodoSchedule } from "../../features/OrgHome/WorkspaceTodos/WorkspaceTodoEdit/WorkspaceTodoSchedule";
import { ProductExpireBatchCreate } from "../../features/ProductExpireBatchCreate/ProductExpireBatchCreate";
import { ProductExpireBatch } from "../../features/ProductExpireBatch/ProductExpireBatch";

import { Products } from "../../features/Products/Products";

import { ProductAPIPlayground } from "../../features/ProductAPIPlayground/ProductAPIPlayground";
import { useBarcodeScanner } from "../../common/useBarcodeScanner";
import { NavigationProp, useNavigation } from "@react-navigation/native";
import { UserLoggedInNavigatorParamList } from "./UserLoggedInNavigatorParamList";
import { OrgStoreAdmin } from "@/src/features/OrgHome/OrgStores/OrgStoreAdmin";
import { EmployeeSelectController } from "@/src/features/UserAdmin/EmployeeSelectController";

import { EmployeeEdit } from "@/src/features/EmployeeEdit/EmployeeEdit";
import { AccountEdit } from "@/src/features/AccountEdit/AccountEdit";
import { UserAdminCreateGroupDevice } from "@/src/features/UserAdmin/UserAdminCreateGroupDevice";
import { UserAdminEditGroupDevice } from "@/src/features/UserAdmin/UserAdminEditGroupDevice";
import * as Sentry from "@sentry/react-native";
import { useRegisterSentry } from "@/src/common/Utils/useRegisterSentry";
import { AccountCreateSelectEmployee } from "@/src/features/UserAdmin/AccountCreateSelectEmployee";
import { CreateAccount } from "@/src/features/UserAdmin/CreateAccount";

import { useEnableGroupAccount } from "@/src/OS/Login/useEnableGroupAccount";
import { WorkspaceSignalSchedule } from "@/src/features/OrgHome/WorkspaceSignals/WorkspaceSignalEdit/WorkspaceSignalSchedule";

import { SignalOpenedByEmployeeScreen } from "@/src/features/Signals/SignalOpenedByEmployee";
import { TodoCategoryAssignedToEmployee } from "@/src/features/Profile/TodoCategoryAssignedToEmployee";
import { useRegisterSession } from "@/src/common/Utils/useRegisterSession";
import { EmployeeScheduleScreen } from "@/src/features/EmployeeSchedule/EmployeeSchedule";
import { OrgAdminTopicsCreate } from "@/src/features/OrgHome/OrgAdminTopics/OrgAdminTopicsCreate";

import { OrgTeamCreate } from "@/src/features/OrgHome/OrgAdmin/OrgAdminTeams/OrgAdminCreateTeam";
import { TeamCreateWhitelistUser } from "@/src/features/TeamCreate/TeamCreateWhitelistUser";
import { CalendarTeamEventCreate } from "@/src/features/CalendarEvent/CalendarTeamEventCreate";
import { CalendarTeamEventEdit } from "@/src/features/CalendarEvent/CalendarTeamEventEdit";
import { OrgAdminTopicsEdit } from "@/src/features/OrgHome/OrgAdminTopics/OrgAdminTopicsEdit";
import { WorkspaceTodoEditScheduledArchiveAt } from "@/src/features/OrgHome/WorkspaceTodos/WorkspaceTodoDetail/WorkspaceTodoEditScheduledArchiveAt";
import { WorkspaceSignalEditScheduledArchiveAt } from "@/src/features/OrgHome/WorkspaceSignals/WorkspaceSignalDetail/WorkspaceSignalEditScheduledArchiveAt";
import { WorkspaceSignalLinkProduct } from "@/src/features/OrgHome/WorkspaceSignals/WorkspaceSignalLinkProduct";
import { RoutineStoreCustomize } from "@/src/features/RoutineStoreCustomize/RoutineStoreCustomize";
import { Lightbox } from "@/src/common/lightbox/Lightbox";
import { CalendarCreate } from "@/src/features/CalendarCreate/CalendarCreate";
import { CalendarEdit } from "@/src/features/CalendarEdit/CalendarEdit";
import { CalendarTeam } from "@/src/features/CalendarTeam/CalendarTeam";
import { WidgetCalendarEventEdit } from "@/src/features/CalendarEvent/WidgetCalendarEventEdit";
import { WidgetCalendarEventCreate } from "@/src/features/CalendarEvent/WidgetCalendarEventCreate";
import { SupportAccessBanner } from "../../features/SupportAccess/SupportAccessBanner";
import { SupportAccessEntry } from "../../features/SupportAccess/SupportAccessEntry";

function UserLoggedInErrorFallback(props: FallbackProps) {
  const insetTop = useSafeAreaInsets().top;
  return (
    <>
      <Box insets={{ top: insetTop }}>
        <AuthenticatedUsersHorizontalList backgroundColor="background" />
      </Box>
      <ErrorFallbackWithLogout resetErrorBoundary={props.resetErrorBoundary} />
    </>
  );
}

function UserLoggedInC() {
  useRegisterSentry();
  return (
    <LazyQueryNetworkBoundrary errorFallback={UserLoggedInErrorFallback}>
      {useCallback(
        (fk) => (
          <StoreSelected fetchKey={fk} />
        ),
        []
      )}
    </LazyQueryNetworkBoundrary>
  );
}
export const UserLoggedIn = React.memo(UserLoggedInC);

function StoreSelected(props: { fetchKey: string }) {
  const data = useLazyLoadQuery<UserLoggedInQuery>(
    graphql`
      query UserLoggedInQuery {
        ...UserLoggedInQuery_query
        currentStore {
          id
          flags
          ...useHasFeatureFlag_store
        }
        home {
          ... on Store {
            id
            timezone

            __typename
          }
          ... on Organisation {
            __typename
          }
        }
      }
    `,
    {},
    {
      fetchKey: props.fetchKey,
      fetchPolicy: "store-and-network",
    }
  );

  useForceTimeZone(
    data.home?.__typename === "Store" ? data.home.timezone : null
  );

  return (
    <LastVisitedTeamProvider
      storeId={data.currentStore ? data.currentStore.id : null}
    >
      <StoreFeatureFlagProvider
        store={data.currentStore ? data.currentStore : null}
      >
        <StoreSelectedComponent query={data} />
      </StoreFeatureFlagProvider>
    </LastVisitedTeamProvider>
  );
}

const modalPresentation =
  Platform.OS === "ios" && Platform.isPad ? "pageSheet" : "modal";
const StoreSelectedComponent = React.memo(StoreSelectedComponentC);
function StoreSelectedComponentC(props: {
  query: UserLoggedInQuery_query$key;
}) {
  const isCompact = useSizeClass().width === SizeClass.COMPACT;
  const intl_tokens = useIntlTokens();

  const data = useFragment(
    graphql`
      fragment UserLoggedInQuery_query on Query {
        me {
          id
          flags
        }
        currentStore {
          tier
          name
          myRole
        }

        home {
          ... on Store {
            id
            name
            timezone

            __typename
          }
          ... on Organisation {
            id
            __typename
          }
        }
      }
    `,
    props.query
  );

  const scope = useMemo(() => {
    if (data.home?.__typename === "Store") {
      return { id: data.home.id, type: "store" as const };
    }
    if (data.home?.__typename === "Organisation") {
      return { id: data.home.id, type: "org" as const };
    }
    return null;
  }, [data.home]);

  useEffect(() => {
    Sentry.setTag("myRole", data.currentStore?.myRole);
    Sentry.setTag("tier", data.currentStore?.tier);
    Sentry.setTag("currentStoreName", data.currentStore?.name);
    if (scope) {
      if (scope.type === "store") {
        Sentry.setTag("storeId", scope.id);
      } else if (scope.type === "org") {
        Sentry.setTag("orgId", scope.id);
      }
    }
  }, [data, scope]);

  useRegisterUser(scope);

  const hasOrg = data.home?.__typename === "Organisation";
  const isGroupAccount = data.currentStore?.myRole === "COWORKER_GROUP";
  const isOnboarded =
    !data.me || data.me?.flags.includes("FinishedSetup") || isGroupAccount;
  const userHasNoStores = !data.home;
  useEnableGroupAccount(isGroupAccount);
  useRegisterSession(!isGroupAccount && !hasOrg && !userHasNoStores);
  useRegisterDevice(userHasNoStores);

  const theme = useTheme();

  const renderWhenReady = useCallback(
    function <T>(a: T): T | null {
      return isOnboarded && !userHasNoStores ? a : null;
    },
    [isOnboarded, userHasNoStores]
  );

  const widgetScreens = useWidgetNavigationScreens();
  const storeHasOperationsPlatform = hasFeatureInTier(
    Features.OPERATIONS_PLATFORM,
    data.currentStore?.tier ?? "premium"
  );

  useHandleNotificationPress();
  const initialRouteName = useMemo(() => {
    if (userHasNoStores) {
      return "NoStore";
    }
    if (!isOnboarded) {
      return "Onboarding";
    }
    if (hasOrg) {
      return "OrgHome";
    }

    if (!storeHasOperationsPlatform) {
      return "Dashboard";
    }
    return "Team";
  }, [hasOrg, isOnboarded, storeHasOperationsPlatform, userHasNoStores]);

  const navigation =
    useNavigation<NavigationProp<UserLoggedInNavigatorParamList>>();

  useBarcodeScanner(
    useCallback(
      (ean) => {
        navigation.navigateDeprecated("Product", {
          screen: "ProductMain",
          params: {
            ean,
            type: "ean",
            state: "details",
          },
        });
      },
      [navigation]
    )
  );

  return (
    <>
      <StatusBar style="light" />
      <SupportAccessBanner />
      <UserLoggedInNavigator.Navigator
        initialRouteName={initialRouteName}
        screenOptions={{
          presentation: modalPresentation,
          headerShown: false,
          headerBackButtonMenuEnabled: false,

          contentStyle: {
            backgroundColor: theme.surface,
          },
          ...(Platform.OS === "android" ? { statusBarStyle: "dark" } : {}),
        }}
      >
        {userHasNoStores ? (
          <UserLoggedInNavigator.Screen
            name="NoStore"
            component={NoStorePage}
            options={{
              presentation: "card",
              headerTitle: "",
              gestureEnabled: false,
            }}
          />
        ) : null}
        {!isOnboarded ? (
          <UserLoggedInNavigator.Screen
            name="Onboarding"
            component={Onboarding}
            options={{
              presentation: "card",
              gestureEnabled: false,
            }}
          />
        ) : null}
        {hasOrg
          ? renderWhenReady(
              <UserLoggedInNavigator.Group
                screenOptions={{
                  title: "",
                }}
              >
                <UserLoggedInNavigator.Screen
                  name="OrgHome"
                  component={OrgHome}
                />
                <UserLoggedInNavigator.Screen
                  name="OrgAdmin"
                  component={OrgAdmin}
                  options={{
                    ...webModalOptions,
                  }}
                />
                <UserLoggedInNavigator.Screen
                  name="OrgWorkspaceAdmin"
                  component={OrgWorkspaceAdmin}
                  options={{
                    ...webModalOptions,
                  }}
                />
                <UserLoggedInNavigator.Screen
                  name="OrgStoreAdmin"
                  component={OrgStoreAdmin}
                  options={{
                    ...webModalOptions,
                  }}
                />
                <UserLoggedInNavigator.Screen
                  name="OrgSpaceCreate"
                  component={OrgSpaceCreate}
                  options={{
                    ...webModalOptions,
                  }}
                />
                <UserLoggedInNavigator.Screen
                  name="OrgSpaceEdit"
                  component={OrgSpaceEdit}
                  options={{
                    ...webModalOptions,
                  }}
                />
                <UserLoggedInNavigator.Screen
                  name="OrgSpaceActiveInfo"
                  component={OrgSpaceActiveInfoScreen}
                  options={{
                    ...webModalOptions,
                  }}
                />
                <UserLoggedInNavigator.Screen
                  name="OrgSpaceWidgetAdd"
                  component={OrgSpaceWidgetAdd}
                  options={{
                    ...webModalOptions,
                  }}
                />
                <UserLoggedInNavigator.Screen
                  name="OrgSpaceWidgetAddNote"
                  component={OrgSpaceWidgetAddNote}
                  options={{
                    ...webModalOptions,
                  }}
                />
                <UserLoggedInNavigator.Screen
                  name="WorkspaceTodoReceivers"
                  component={WorkspaceTodoReceivers}
                  options={{
                    ...webModalOptions,
                  }}
                />
                <UserLoggedInNavigator.Screen
                  name="WorkspaceSignalReceivers"
                  component={WorkspaceSignalReceivers}
                  options={{
                    ...webModalOptions,
                  }}
                />
                <UserLoggedInNavigator.Screen
                  name="WorkspaceTodoSchedule"
                  component={WorkspaceTodoSchedule}
                  options={{
                    ...webModalOptions,
                  }}
                />
                <UserLoggedInNavigator.Screen
                  name="WorkspaceTodoEditScheduledArchiveAt"
                  component={WorkspaceTodoEditScheduledArchiveAt}
                  options={{
                    ...webModalOptions,
                  }}
                />
                <UserLoggedInNavigator.Screen
                  name="WorkspaceSignalEditScheduledArchiveAt"
                  component={WorkspaceSignalEditScheduledArchiveAt}
                  options={{
                    ...webModalOptions,
                  }}
                />
                <UserLoggedInNavigator.Screen
                  name="WorkspaceSignalSchedule"
                  component={WorkspaceSignalSchedule}
                  options={{
                    ...webModalOptions,
                  }}
                />
                <UserLoggedInNavigator.Screen
                  name="OrgSpaceWidgetAddFile"
                  component={OrgSpaceWidgetAddFile}
                  options={{
                    ...webModalOptions,
                  }}
                />
                <UserLoggedInNavigator.Screen
                  name="WorkspaceProduct"
                  component={WorkspaceProduct}
                  options={{
                    ...webModalOptions,
                  }}
                />
                <UserLoggedInNavigator.Screen
                  name="OrgUserInvite"
                  component={OrgUserInvite}
                  options={{
                    ...webModalOptions,
                  }}
                />
                <UserLoggedInNavigator.Screen
                  name="OrgUserEdit"
                  component={OrgUserEdit}
                  options={{
                    ...webModalOptions,
                  }}
                />
                <UserLoggedInNavigator.Screen
                  name="OrgAdminTopicsCreate"
                  component={OrgAdminTopicsCreate}
                  options={{
                    ...webModalOptions,
                  }}
                />
                <UserLoggedInNavigator.Screen
                  name="OrgAdminTopicsEdit"
                  component={OrgAdminTopicsEdit}
                  options={{
                    ...webModalOptions,
                  }}
                />
                <UserLoggedInNavigator.Screen
                  name="OrgStoreCreate"
                  component={OrgStoreCreate}
                  options={{
                    ...webModalOptions,
                  }}
                />
                <UserLoggedInNavigator.Screen
                  name="OrgWorkspaceCreate"
                  component={OrgWorkspaceCreate}
                  options={{
                    ...webModalOptions,
                  }}
                />
                <UserLoggedInNavigator.Screen
                  name="OrgAdminCreateTeam"
                  component={OrgTeamCreate}
                  options={{
                    ...webModalOptions,
                  }}
                />
                <UserLoggedInNavigator.Screen
                  name="WorkspaceTodoEdit"
                  component={WorkspaceTodoEditNavigator}
                  options={{
                    ...webModalOptions,
                  }}
                />
                <UserLoggedInNavigator.Screen
                  name="WorkspaceTodoEditLinkProduct"
                  component={WorkspaceTodoLinkProduct}
                  options={{
                    ...webModalOptions,
                  }}
                />
                <UserLoggedInNavigator.Screen
                  name="WorkspaceSignalEditLinkProduct"
                  component={WorkspaceSignalLinkProduct}
                  options={{
                    ...webModalOptions,
                  }}
                />
                <UserLoggedInNavigator.Screen
                  name="WorkspaceSignalEdit"
                  component={WorkspaceSignalEditNavigator}
                  options={{
                    ...webModalOptions,
                  }}
                />
              </UserLoggedInNavigator.Group>
            )
          : null}
        {renderWhenReady(
          <UserLoggedInNavigator.Group>
            <UserLoggedInNavigator.Screen
              name="Team"
              component={TeamNavigator}
              options={{
                headerShown: false,
                presentation: "card",
                headerShadowVisible: false,
                animation: "fade",
                freezeOnBlur: false,

                title: "",

                ...(Platform.OS === "android"
                  ? { statusBarStyle: "light" }
                  : {}),
              }}
              initialParams={{
                teamId: undefined,
              }}
            />
            <UserLoggedInNavigator.Screen
              name="Support"
              component={SupportScreen}
              options={({ navigation }) => ({
                headerLeft: () => (
                  <HeaderButton type="CANCEL" onPress={navigation.goBack} />
                ),
                contentStyle: {
                  backgroundColor: theme.surface,
                },
                headerShown: true,
                headerTitleAlign: "center",
                title: intl_tokens.Help,
              })}
            />
            <UserLoggedInNavigator.Screen
              name="SupportAccessEntry"
              component={SupportAccessEntry}
              options={{
                headerShown: false,
                presentation: "card",
              }}
            />
            <UserLoggedInNavigator.Screen
              name="WebView"
              component={WebViewScreen}
              options={webModalOptions}
            />

            <UserLoggedInNavigator.Screen
              name="RoutineEdit"
              options={(p) => ({
                presentation: modalPresentation,

                headerShown: false,
                gestureEnabled: false,

                ...webModalOptions,
              })}
              component={RoutineEdit}
            />
            <UserLoggedInNavigator.Screen
              name="TeamScheduleHistory"
              component={TeamScheduleHistoryStack}
              options={{
                presentation: "card",
                gestureEnabled: false,
                headerShown: false,
              }}
            />

            <UserLoggedInNavigator.Screen
              name="TeamPLU"
              component={TeamPLUScreen}
              options={() => ({
                headerShown: true,
                presentation: "card",
                headerShadowVisible: false,
              })}
            />

            <UserLoggedInNavigator.Screen
              name="TeamScheduleAdmin"
              component={TeamScheduleAdmin}
              options={({ navigation }) => ({
                headerLeft:
                  Platform.OS === "android"
                    ? undefined
                    : () => (
                        <HeaderButton
                          type="CLOSE"
                          onPress={navigation.goBack}
                        />
                      ),

                headerShadowVisible: false,
                title: "",
                ...webModalOptions,
              })}
            />
            <UserLoggedInNavigator.Screen
              name="Dashboard"
              initialParams={{
                dashboardId: undefined,
              }}
              options={{
                animation: "none",
                presentation: "fullScreenModal",
                headerShown: false,
                freezeOnBlur: false,

                gestureEnabled: false,
                contentStyle: {
                  backgroundColor: theme.background,
                },
              }}
            >
              {({ navigation, route }) => {
                return (
                  <StorecastScreen
                    navigation={navigation}
                    route={route}
                    hasOrg={hasOrg}
                    asHome={!storeHasOperationsPlatform}
                    storeName={data.currentStore?.name ?? ""}
                  />
                );
              }}
            </UserLoggedInNavigator.Screen>

            <UserLoggedInNavigator.Screen
              name="StorecastSettings"
              component={StorecastSettings}
              options={{
                gestureEnabled: false,
                headerShown: false,
                ...webModalOptions,
              }}
            />

            <UserLoggedInNavigator.Screen
              name="TodoEdit"
              component={TodoEdit}
              options={{
                gestureEnabled: true,

                ...webModalOptions,
                headerShown: false,
              }}
            />
            <UserLoggedInNavigator.Screen
              name="TodoResponseNumber"
              component={TodoResponseNumberScreen}
              options={{
                gestureEnabled: false,
                presentation: "transparentModal",
                animation: "fade",
                contentStyle: {
                  backgroundColor: "transparent",
                },
                headerShown: false,
              }}
            />
            <UserLoggedInNavigator.Screen
              name="KPITeam"
              component={KPITeamScreen}
              options={{
                headerShown: true,
                title: "",
                ...webModalOptions,
              }}
            />
            <UserLoggedInNavigator.Screen
              name="TodoCategory"
              component={TodoCategoryScreen}
              options={{
                headerShown: true,
                ...webModalOptions,
              }}
            />
            <UserLoggedInNavigator.Screen
              name="TodoCategoryAssignedToEmployee"
              component={TodoCategoryAssignedToEmployee}
              options={{
                headerShown: true,
                ...webModalOptions,
              }}
            />
            <UserLoggedInNavigator.Screen
              name="Signals"
              component={SignalsScreen}
              options={{
                presentation: modalPresentation,
                headerShown: true,

                ...webModalOptions,
              }}
            />
            <UserLoggedInNavigator.Screen
              name="SignalDetail"
              component={SignalDetailScreen}
              options={{
                presentation: modalPresentation,
                ...webModalOptions,
              }}
            />
            <UserLoggedInNavigator.Screen
              name="SignalOpenedBy"
              component={SignalOpenedByScreen}
              options={{
                presentation: modalPresentation,
                ...webModalOptions,
              }}
            />
            <UserLoggedInNavigator.Screen
              name="SignalOpenedByEmployee"
              component={SignalOpenedByEmployeeScreen}
              options={{
                presentation: modalPresentation,
                ...webModalOptions,
              }}
            />

            <UserLoggedInNavigator.Screen
              name="TodoMoveToCategory"
              component={TodoEditMoveToCategory}
              options={{
                headerShown: false,
                ...webModalOptions,
              }}
            />
            <UserLoggedInNavigator.Screen
              name="TodoCreate"
              component={TodoCreateScreen}
              options={{ gestureEnabled: false, ...webModalOptions }}
            />
            <UserLoggedInNavigator.Screen
              name="StorecastShowFile"
              component={StorecastShowFile}
              options={({ navigation }) => ({
                headerShown: false,
                presentation: isCompact
                  ? "transparentModal"
                  : modalPresentation,
                headerLeft: () => (
                  <HeaderButton type="CANCEL" onPress={navigation.goBack} />
                ),
              })}
            />

            <UserLoggedInNavigator.Screen
              name="StorecastCreate"
              component={StorecastCreate}
              options={({ navigation }) => ({
                headerShown: true,

                ...webModalOptions,
              })}
            />

            <UserLoggedInNavigator.Screen
              name="FileFocus"
              component={FileFocus}
              options={({ navigation }) => ({
                presentation: "transparentModal",
                headerShown: true,
                title: "",
                headerLeft:
                  Platform.OS === "ios"
                    ? () => (
                        <HeaderButton
                          type="CANCEL"
                          onPress={() => {
                            navigation.goBack();
                          }}
                        />
                      )
                    : undefined,
              })}
            />
            <UserLoggedInNavigator.Screen
              name="Files"
              component={FileNavigator}
              options={{
                presentation: modalPresentation,
                headerShown: false,
              }}
            />

            <UserLoggedInNavigator.Screen
              name="File"
              component={FileScreen}
              options={(prop) => ({
                presentation: "transparentModal",
                headerShown: true,
                title: "",
                headerLeft:
                  Platform.OS === "ios"
                    ? () => (
                        <HeaderButton
                          onPress={() => prop.navigation.goBack()}
                          type="CLOSE"
                        />
                      )
                    : undefined,
                ...webModalOptions,
              })}
            />

            <UserLoggedInNavigator.Screen
              name="FileInfo"
              component={FileInfoScreen}
              options={() => ({
                presentation: modalPresentation,
                headerShown: false,
                title: "",
                ...webModalOptions,
              })}
            />

            <UserLoggedInNavigator.Screen
              name="RoutineOccasion"
              component={RoutineOccasionNavigator}
              options={{
                headerShown: false,
                presentation: "fullScreenModal",
                ...webModalOptions,
              }}
            />
            <UserLoggedInNavigator.Screen
              name="RoutineStoreCustomize"
              component={RoutineStoreCustomize}
              options={{
                headerShown: false,
                gestureEnabled: false,
                ...webModalOptions,
              }}
            />

            <UserLoggedInNavigator.Screen
              name="RoutineDetail"
              options={{
                presentation: modalPresentation,
                headerShown: false,
              }}
              component={RoutineDetailNavigator}
            />
            <UserLoggedInNavigator.Screen
              name="Profile"
              component={ProfileNavigator}
              options={{
                headerShown: false,
                ...webModalOptions,
              }}
            />
            <UserLoggedInNavigator.Screen
              name="EmployeeEdit"
              component={withWebModal(EmployeeEdit)}
              options={{
                headerShown: false,
                ...webModalOptions,
              }}
            />
            <UserLoggedInNavigator.Screen
              name="CreateAccount"
              component={CreateAccount}
              options={{
                headerShown: false,
                ...webModalOptions,
              }}
            />
            <UserLoggedInNavigator.Screen
              name="AccountEdit"
              component={AccountEdit}
              options={{
                headerShown: false,
                ...webModalOptions,
              }}
            />
            <UserLoggedInNavigator.Screen
              name="AccountCreateSelectEmployee"
              component={AccountCreateSelectEmployee}
              options={{
                headerShown: false,
                ...webModalOptions,
              }}
            />
            <UserLoggedInNavigator.Screen
              name="GroupDeviceEdit"
              component={UserAdminEditGroupDevice}
              options={{
                headerShown: false,
                ...webModalOptions,
              }}
            />
            <UserLoggedInNavigator.Screen
              name="UserAdminCreateGroupDevice"
              component={UserAdminCreateGroupDevice}
              options={{
                headerShown: false,
                ...webModalOptions,
              }}
            />
            <UserLoggedInNavigator.Screen
              name="Product"
              component={Product}
              options={{
                headerShown: false,
                ...webModalOptions,
              }}
            />
            <UserLoggedInNavigator.Screen
              name="ProductAPIPlayground"
              component={ProductAPIPlayground}
              options={{
                headerShown: false,
                ...webModalOptions,
              }}
            />
            <UserLoggedInNavigator.Screen
              name="ProductExpireBatch"
              component={ProductExpireBatch}
              options={{
                headerShown: false,
                ...webModalOptions,
              }}
            />
            <UserLoggedInNavigator.Screen
              name="Products"
              component={Products}
              options={{
                headerShown: false,
                ...webModalOptions,
              }}
            />
            <UserLoggedInNavigator.Screen
              name="EmployeeSchedule"
              component={EmployeeScheduleScreen}
              options={{
                headerShown: false,
                ...webModalOptions,
              }}
            />
            <UserLoggedInNavigator.Screen
              name="ProductDateTracker"
              component={ProductDateTrackerNavigator}
              options={{
                headerShown: false,
                ...webModalOptions,
              }}
            />
            <UserLoggedInNavigator.Screen
              name="ProductExpireBatchCreate"
              component={ProductExpireBatchCreate}
              options={{
                headerShown: false,
                ...webModalOptions,
              }}
            />
            <UserLoggedInNavigator.Screen
              name="CalendarTeam"
              component={CalendarTeam}
              options={{
                headerShown: false,
                ...webModalOptions,
              }}
            />
            <UserLoggedInNavigator.Screen
              name="CalendarTeamEventCreate"
              component={CalendarTeamEventCreate}
              options={{
                headerShown: false,
                ...webModalOptions,
              }}
            />
            <UserLoggedInNavigator.Screen
              name="CalendarTeamEventEdit"
              component={CalendarTeamEventEdit}
              options={{
                headerShown: false,
                ...webModalOptions,
              }}
            />
            <UserLoggedInNavigator.Screen
              name="CalendarCreate"
              component={CalendarCreate}
              options={{
                headerShown: false,
                ...webModalOptions,
              }}
            />
            <UserLoggedInNavigator.Screen
              name="CalendarEdit"
              component={CalendarEdit}
              options={{
                headerShown: false,
                ...webModalOptions,
              }}
            />
            <UserLoggedInNavigator.Screen
              name="WidgetCalendarEventEdit"
              component={WidgetCalendarEventEdit}
              options={{
                headerShown: false,
                ...webModalOptions,
              }}
            />
            <UserLoggedInNavigator.Screen
              name="WidgetCalendarEventCreate"
              component={WidgetCalendarEventCreate}
              options={{
                headerShown: false,
                ...webModalOptions,
              }}
            />
            <UserLoggedInNavigator.Screen
              component={TeamCreate}
              name="TeamCreate"
              options={{
                headerShown: true,
                ...webModalOptions,
              }}
            />
            <UserLoggedInNavigator.Screen
              component={TeamCreateWhitelistUser}
              name="TeamCreateWhitelistUser"
              options={{
                headerShown: true,
                ...webModalOptions,
              }}
            />
            <UserLoggedInNavigator.Screen
              component={StoreAdminNavigator}
              name="StoreAdmin"
              options={{
                presentation: modalPresentation,
                headerShown: false,

                ...webModalOptions,
              }}
            />

            <UserLoggedInNavigator.Screen
              component={EmployeeRolesAdmin}
              name="EmployeeRolesAdmin"
              options={{
                headerShown: false,
                ...webModalOptions,
              }}
            />
            <UserLoggedInNavigator.Screen
              component={EmployeeRoleCreate}
              name="EmployeeRoleCreate"
              options={{
                presentation: "modal",
                headerShown: false,
                ...webModalOptions,
              }}
            />
            <UserLoggedInNavigator.Screen
              component={EmployeeRoleEdit}
              name="EmployeeRoleEdit"
              options={{
                presentation: "modal",
                headerShown: false,
                ...webModalOptions,
              }}
            />

            <UserLoggedInNavigator.Screen
              name="TeamAdmin"
              component={TeamAdmin}
              options={{
                presentation: modalPresentation,
                headerShown: false,
                gestureEnabled: false,

                ...webModalOptions,
              }}
            />

            <UserLoggedInNavigator.Screen
              component={StoreAnalyticsScreen}
              name="StoreAnalytics"
              options={{
                headerTitle: "Butiksanalys",
                presentation: "card",
                headerBackTitle: intl_tokens.Back,
                headerShown: true,
              }}
            />

            <UserLoggedInNavigator.Screen
              name="EmaginWebview"
              component={EmaginWebview}
              options={({ route, navigation }) => ({
                presentation: "transparentModal",
                headerShown: true,
                headerLeft:
                  Platform.OS === "ios"
                    ? () => (
                        <HeaderButton
                          type="CLOSE"
                          onPress={navigation.goBack}
                        />
                      )
                    : undefined,
                title: route.params.title,
              })}
            />

            <UserLoggedInNavigator.Screen
              component={ActivatePLUFromStoreFilesScreen}
              name="ActivatePLUFromStoreOffice"
              options={{
                headerShown: true,
                ...webModalOptions,
              }}
            />

            <UserLoggedInNavigator.Screen
              component={PLUProductEditScreen}
              name="PLUItemEdit"
              options={({ navigation, route }) => ({
                ...webModalOptions,
              })}
            />

            {widgetScreens}

            <UserLoggedInNavigator.Screen
              component={PLUProductCreateScreen}
              name="PLUProductCreate"
              options={{ ...webModalOptions }}
            />

            <UserLoggedInNavigator.Screen
              component={SupportTeamSchedule}
              name="SupportTeamSchedule"
              options={({ navigation }) => ({
                headerLeft: () => (
                  <HeaderButton type="CLOSE" onPress={navigation.goBack} />
                ),
                contentStyle: {
                  backgroundColor: theme.surface,
                },
                headerShown: true,
                title: "",
                headerTitleAlign: "center",
              })}
            />

            <UserLoggedInNavigator.Screen
              component={PLUCategoryCreate}
              name="PLUCategoryCreate"
              options={{ headerShown: true, ...webModalOptions }}
            />

            <UserLoggedInNavigator.Screen
              component={PLUCategoryEdit}
              name="PLUCategoryEdit"
              options={{ headerShown: true, ...webModalOptions }}
            />

            <UserLoggedInNavigator.Screen
              name="KPI"
              component={KPI}
              options={{
                ...webModalOptions,
              }}
            />

            <UserLoggedInNavigator.Screen
              name="KPIEditSubTeam"
              component={KPIEditSubTeam}
              options={({ navigation }) => ({
                presentation: modalPresentation,
                ...webModalOptions,
              })}
            />

            <UserLoggedInNavigator.Screen
              component={KPIAnalytics}
              name="KPIAnalytics"
              options={({ route, navigation }) => ({
                headerShown: true,
                title: route.params.title,
                presentation: "fullScreenModal",
                headerShadowVisible: false,
                headerLeft:
                  Platform.OS === "android"
                    ? undefined
                    : () => (
                        <HeaderButton
                          type="CLOSE"
                          onPress={navigation.goBack}
                        />
                      ),
                ...webModalOptions,
              })}
            />

            <UserLoggedInNavigator.Screen
              component={KPIEdit}
              name="KPIEdit"
              options={{
                headerShown: false,
                presentation: modalPresentation,
                gestureEnabled: false,
                ...webModalOptions,
              }}
            />

            <UserLoggedInNavigator.Screen
              component={KPICreate}
              name="KPICreate"
              options={{
                gestureEnabled: false,

                headerShown: true,
                presentation: modalPresentation,
                ...webModalOptions,
              }}
            />

            <UserLoggedInNavigator.Screen
              name="KPICreateSubTeam"
              component={KPICreateSubTeam}
              options={{
                presentation: modalPresentation,
                headerShown: false,
                ...webModalOptions,
              }}
            />

            <UserLoggedInNavigator.Screen
              name="TaskExecutionInstructionsStack"
              component={TaskExecutionInstructions}
              options={webModalOptions}
            />

            <UserLoggedInNavigator.Screen
              component={EmployeeScheduleEdit}
              name="EmployeeScheduleEdit"
              options={webModalOptions}
            />

            <UserLoggedInNavigator.Screen
              component={WidgetTaskCollectionScreen}
              name="WidgetTaskCollection"
              options={({ navigation }) => ({
                headerShown: true,

                ...webModalOptions,
              })}
            />

            <UserLoggedInNavigator.Screen
              component={WidgetRoutinePositivePercentageScreen}
              name="WidgetRoutinePositivePercentage"
              options={({ navigation }) => ({
                headerTitle: "",
                headerLargeTitle: false,
                presentation: modalPresentation,
                headerLargeTitleHideShadow: true,
                headerStyle: {
                  backgroundColor: theme.background,
                },
                headerShown: true,
                headerLeft:
                  Platform.OS === "android"
                    ? undefined
                    : () => (
                        <HeaderButton
                          nativeHeader
                          type="CLOSE"
                          onPress={navigation.goBack}
                        />
                      ),
              })}
            />
          </UserLoggedInNavigator.Group>
        )}
      </UserLoggedInNavigator.Navigator>

      <Lightbox />

      <PortalHost name={AbsolutePopoverHostName} />
      {isGroupAccount ? <EmployeeSelectController /> : null}
    </>
  );
}
